import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import CircularProgress from '@material-ui/core/CircularProgress';

const AssetLoadMore = ({ onLoadMore, disabled, classes }) => {
    return (
        <div
            onClick={onLoadMore}
            className={classes.wrapper}
        >
            <CircularProgress 
                size={24} 
                thickness={4}
                className={classes.spinner}
            />
        </div>
    );
};

AssetLoadMore.propTypes = {
    onLoadMore: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
};

const style = () => ({
    wrapper: ({ disabled }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: disabled ? 'default' : 'pointer',
        pointerEvents: disabled ? 'none' : 'auto',
        padding: '16px',
        backgroundColor: 'transparent',
        borderRadius: '4px',
        transition: 'all 0.2s ease',
    }),
    spinner: ({ disabled }) => ({
        color: disabled ? '#d0d0d0' : '#1976d2',
        opacity: disabled ? 0.5 : 1,
    }),
});

export default injectSheet(style)(AssetLoadMore);



// WEBPACK FOOTER //
// ./src/components/assets/AssetLoadMore.js